import {
    updateConversationMessages,
    updateReferralConversations,
} from 'store/userSupport/userSupportSlice';

// RTK Query onQueryStarted handlers for the user-support REST writes. While the WebSocket still
// feeds the referral chat pane (dual-run), a REST write gets no socket push until the server's
// polling loop runs, so results are written into the userSupport slice directly. Failures are
// surfaced by the caller.

/**
 * Puts a sent message into both message stores: the socket-fed slice, and the getMessages query
 * cache used when reads go over REST. Writing it straight into the cache avoids refetching the
 * whole conversation after every send.
 */
export const syncSentMessage = async (
    { conversationId },
    { dispatch, queryFulfilled },
    apiUtil,
) => {
    let message;
    try {
        ({ data: message } = await queryFulfilled);
    } catch {
        return;
    }
    dispatch(
        updateConversationMessages({
            conversationId,
            messages: { [message.messageId]: message },
        }),
    );
    dispatch(
        apiUtil.updateQueryData('getMessages', conversationId, (draft) => {
            if (!draft.some(({ messageId }) => messageId === message.messageId)) {
                draft.push(message);
            }
        }),
    );
};

/**
 * Refreshes a changed conversation in the socket-fed list, if it holds it. Query-backed lists
 * refresh themselves through the mutation's invalidated tags.
 */
export const syncChangedConversationToSlice = async (
    { conversationId },
    { dispatch, getState, queryFulfilled },
    getConversationEndpoint,
) => {
    try {
        await queryFulfilled;
    } catch {
        return;
    }
    if (!getState().userSupport.referralConversations?.[conversationId]) {
        return;
    }
    const { data: conversation } = await dispatch(
        getConversationEndpoint.initiate(conversationId, { subscribe: false, forceRefetch: true }),
    );
    if (conversation) {
        dispatch(
            updateReferralConversations({ conversations: { [conversationId]: conversation } }),
        );
    }
};
